import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userData: null,
    userExists: false,
    isAdmin: false,
  },
  reducers: {
    setUserData: (state, action) => {
      // console.log("Reducer received:", action.payload);
      state.userData = action.payload.userData;
      state.userExists = action.payload.userExists;
      state.isAdmin = action.payload.isAdmin;
    },
    resetUser: (state) => {
      state.userData = null;
      state.userExists = false;
      state.isAdmin = false;
    },
  },
});

export const { setUserData, resetUser } = userSlice.actions;

export const selectUserData = (state) => {
  // console.log("Current Redux state:", state.user);
  return state.user.userData;
};
export const selectUserExists = (state) => state.user.userExists;
export const selectIsAdmin = (state) => state.user.isAdmin;

export default userSlice.reducer;